var keyMirror = require('keymirror');

module.exports = {

    ActionTypes: keyMirror({
        API_ERROR:                       null,
        FORM_SUBMIT_ERROR:               null,
        FORM_SUBMIT_SUCCESS:             null,
        API_EXCEPTION:                   null,

        ACCESS_GROUP_LIST:               null,
        ACCESS_GROUP_LIST_ERROR:         null,
        ACCESS_GROUP_INFO:               null,
        ACCESS_GROUP_INFO_ERROR:         null,
        ACCESS_GROUP_SAVE:               null,
        ACCESS_GROUP_SAVE_ERROR:         null,
        ACCESS_GROUP_UPDATE:             null,
        ACCESS_GROUP_UPDATE_ERROR:       null,
        ACCESS_GROUP_DELETE:             null,
        ACCESS_GROUP_DELETE_ERROR:       null,

        ADDRESS_INFO:                    null,
        ADDRESS_INFO_ERROR:              null,
        ADDRESS_SAVE:                    null,
        ADDRESS_SAVE_ERROR:              null,
        ADDRESS_UPDATE:                  null,
        ADDRESS_UPDATE_ERROR:            null,

        ASSET_LIST_REQUEST: null,
        ASSET_LIST_SUCCESS: null,
        ASSET_LIST_FAILURE: null,
        ASSET_ADD_REQUEST: null,
        ASSET_ADD_SUCCESS: null,
        ASSET_ADD_FAILURE: null,
        ASSET_UPDATE_REQUEST: null,
        ASSET_UPDATE_SUCCESS: null,
        ASSET_UPDATE_FAILURE: null,
        ASSET_DELETE_REQUEST: null,
        ASSET_DELETE_SUCCESS: null,
        ASSET_DELETE_FAILURE: null,

        ASSET_HISTORY_REQUEST:           null,
        ASSET_HISTORY_SUCCESS:           null,
        ASSET_HISTORY_FAILURE:           null,
        ASSET_INFO_REQUEST: null,
        ASSET_INFO_SUCCESS: null,
        ASSET_INFO_FAILURE: null,

        ASSET_CREATE: null,
        ASSET_EDIT: null,
        ASSET_UPDATE: null,
        ASSET_DISCARD: null,

        ASSET_DELETE:                    null,
        ASSET_DELETE_ERROR:              null,

        ASSETTYPE_LIST_REQUEST: null,
        ASSETTYPE_LIST_SUCCESS: null,
        ASSETTYPE_LIST_FAILURE: null,

        ASSIGNMENT_LIST:                 null,
        ASSIGNMENT_LIST_ERROR:           null,
        ASSIGNMENT_INFO:                 null,
        ASSIGNMENT_INFO_ERROR:           null,
        ASSIGNMENT_RUN_REQUEST: null,
        ASSIGNMENT_RUN_SUCCESS: null,
        ASSIGNMENT_RUN_FAILURE: null,
        ASSIGNMENT_SAVE:                 null,
        ASSIGNMENT_SAVE_ERROR:           null,
        ASSIGNMENT_UPDATE:               null,
        ASSIGNMENT_UPDATE_ERROR:         null,
        ASSIGNMENT_DELETE:               null,
        ASSIGNMENT_DELETE_ERROR:         null,

        ATTRIBUTE_LIST_REQUEST:          null,
        ATTRIBUTE_LIST_SUCCESS:          null,
        ATTRIBUTE_LIST_FAILURE:          null,
        ATTRIBUTE_ACTIVE_LIST_REQUEST:   null,
        ATTRIBUTE_ACTIVE_LIST_SUCCESS:   null,
        ATTRIBUTE_ACTIVE_LIST_FAILURE:   null,
        ATTRIBUTE_SET_ACTIVE_REQUEST:    null,
        ATTRIBUTE_SET_ACTIVE_SUCCESS:    null,
        ATTRIBUTE_SET_ACTIVE_FAILURE:    null,
        ATTRIBUTE_SET_REQUIRED_REQUEST:  null,
        ATTRIBUTE_SET_REQUIRED_SUCCESS:  null,
        ATTRIBUTE_SET_REQUIRED_FAILURE:  null,
        ATTRIBUTE_SET_REGISTRATION_FIELD_REQUEST:  null,
        ATTRIBUTE_SET_REGISTRATION_FIELD_SUCCESS:  null,
        ATTRIBUTE_SET_REGISTRATION_FIELD_FAILURE:  null,
        ATTRIBUTE_SET_USER_EDITABLE_REQUEST: null,
        ATTRIBUTE_SET_USER_EDITABLE_SUCCESS: null,
        ATTRIBUTE_SET_USER_EDITABLE_FAILURE: null,

        AUTH_INFO:                       null,
        AUTH_INFO_ERROR:                 null,

        BADGE_LIST:                      null,
        BADGE_LIST_ERROR:                null,

        CATEGORY_INFO_REQUEST:           null,
        CATEGORY_INFO_SUCCESS:           null,
        CATEGORY_INFO_FAILURE:           null,
        CATEGORY_STATS:                  null,
        CATEGORY_STATS_ERROR:            null,
        CATEGORY_LIST:                   null,
        CATEGORY_LIST_ERROR:             null,
        CATEGORY_INFO_ERROR:             null,
        CATEGORY_SAVE:                   null,
        CATEGORY_SAVE_ERROR:             null,
        CATEGORY_UPDATE:                 null,
        CATEGORY_UPDATE_ERROR:           null,
        CATEGORY_DELETE:                 null,
        CATEGORY_DELETE_ERROR:           null,
        CATEGORY_ORGANISATION_ADD_REQUEST:    null,
        CATEGORY_ORGANISATION_ADD_SUCCESS:    null,
        CATEGORY_ORGANISATION_ADD_FAILURE:    null,
        CATEGORY_ORGANISATION_UPDATE_REQUEST: null,
        CATEGORY_ORGANISATION_UPDATE_SUCCESS: null,
        CATEGORY_ORGANISATION_UPDATE_FAILURE: null,
        CATEGORY_ORGANISATION_REMOVE_REQUEST: null,
        CATEGORY_ORGANISATION_REMOVE_SUCCESS: null,
        CATEGORY_ORGANISATION_REMOVE_FAILURE: null,
        CATEGORY_ROOT_LIST_REQUEST:           null,
        CATEGORY_ROOT_LIST_SUCCESS:           null,
        CATEGORY_ROOT_LIST_FAILURE:           null,

        CALENDAR_LIST:                   null,
        CALENDAR_LIST_ERROR:             null,
        CALENDAR_INFO:                   null,
        CALENDAR_INFO_ERROR:             null,
        CALENDAR_SAVE:                   null,
        CALENDAR_SAVE_ERROR:             null,
        CALENDAR_UPDATE:                 null,
        CALENDAR_UPDATE_ERROR:           null,
        CALENDAR_DELETE:                 null,
        CALENDAR_DELETE_ERROR:           null,

        CALENDAR_EVENT_LIST:             null,
        CALENDAR_EVENT_LIST_ERROR:       null,

        CERTIFICATE_ADD_REQUEST: null,
        CERTIFICATE_ADD_SUCCESS: null,
        CERTIFICATE_ADD_FAILURE: null,
        CERTIFICATE_LIST_REQUEST: null,
        CERTIFICATE_LIST_SUCCESS: null,
        CERTIFICATE_LIST_FAILURE: null,
        CERTIFICATE_INFO_REQUEST: null,
        CERTIFICATE_INFO_SUCCESS: null,
        CERTIFICATE_INFO_FAILURE: null,
        CERTIFICATE_UPDATE_REQUEST: null,
        CERTIFICATE_UPDATE_SUCCESS: null,
        CERTIFICATE_UPDATE_FAILURE: null,
        CERTIFICATE_DELETE_REQUEST: null,
        CERTIFICATE_DELETE_SUCCESS: null,
        CERTIFICATE_DELETE_FAILURE: null,

        CERTIFICATE_ADD_FIELD_REQUEST: null,
        CERTIFICATE_ADD_FIELD_SUCCESS: null,
        CERTIFICATE_ADD_FIELD_FAILURE: null,
        CERTIFICATE_UPDATE_FIELD_REQUEST: null,
        CERTIFICATE_UPDATE_FIELD_SUCCESS: null,
        CERTIFICATE_UPDATE_FIELD_FAILURE: null,
        CERTIFICATE_REMOVE_FIELD_REQUEST: null,
        CERTIFICATE_REMOVE_FIELD_SUCCESS: null,
        CERTIFICATE_REMOVE_FIELD_FAILURE: null,

        COMPLIANCE_LIST_REQUEST: null,
        COMPLIANCE_LIST_SUCCESS: null,
        COMPLIANCE_LIST_FAILURE: null,
        COMPLIANCE_INFO_REQUEST: null,
        COMPLIANCE_INFO_SUCCESS: null,
        COMPLIANCE_INFO_FAILURE: null,
        COMPLIANCE_ADD_REQUEST: null,
        COMPLIANCE_ADD_SUCCESS: null,
        COMPLIANCE_ADD_FAILURE: null,
        COMPLIANCE_UPDATE_REQUEST: null,
        COMPLIANCE_UPDATE_SUCCESS: null,
        COMPLIANCE_UPDATE_FAILURE: null,
        COMPLIANCE_DELETE_REQUEST: null,
        COMPLIANCE_DELETE_SUCCESS: null,
        COMPLIANCE_DELETE_FAILURE: null,

        COMPLIANCE_PROGRESS_REQUEST: null,
        COMPLIANCE_PROGRESS_SUCCESS: null,
        COMPLIANCE_PROGRESS_FAILURE: null,

        COMPLIANCE_ASSIGN_USERS_REQUEST: null,
        COMPLIANCE_ASSIGN_USERS_SUCCESS: null,
        COMPLIANCE_ASSIGN_USERS_FAILURE: null,
        COMPLIANCE_CLEAR_USERS_REQUEST:  null,
        COMPLIANCE_CLEAR_USERS_SUCCESS:  null,
        COMPLIANCE_CLEAR_USERS_FAILURE:  null,

        COMPLIANCE_NEW: null,
        COMPLIANCE_EDIT: null,
        COMPLIANCE_DISCARD: null,
        COMPLIANCE_UPDATE_DRAFT: null,
        COMPLIANCE_ADD_SKILL: null,
        COMPLIANCE_REMOVE_SKILL: null,

        CONTACT_LIST:                    null,
        CONTACT_LIST_ERROR:              null,
        CONTACT_INFO:                    null,
        CONTACT_INFO_ERROR:              null,
        CONTACT_SAVE:                    null,
        CONTACT_SAVE_ERROR:              null,
        CONTACT_UPDATE:                  null,
        CONTACT_UPDATE_ERROR:            null,
        CONTACT_DELETE:                  null,
        CONTACT_DELETE_ERROR:            null,

        COURSE_LIST:                      null,
        COURSE_LIST_ERROR:                null,
        COURSE_INFO:                      null,
        COURSE_INFO_ERROR:                null,
        COURSE_SAVE:                      null,
        COURSE_SAVE_ERROR:                null,
        COURSE_UPDATE:                    null,
        COURSE_UPDATE_ERROR:              null,
        COURSE_DELETE:                    null,
        COURSE_DELETE_ERROR:              null,
        COURSE_ASSET_LIST:                null,
        COURSE_ASSET_LIST_ERROR:          null,
        COURSE_ASSET_INFO:                null,
        COURSE_ASSET_INFO_ERROR:          null,
        COURSE_ASSET_ADD:                 null,
        COURSE_ASSET_ADD_ERROR:           null,
        COURSE_ASSET_UPDATE:              null,
        COURSE_ASSET_UPDATE_ERROR:        null,
        COURSE_ASSET_DELETE:              null,
        COURSE_ASSET_DELETE_ERROR:        null,
        COURSE_EVENT_LIST:                null,
        COURSE_EVENT_LIST_ERROR:          null,
        COURSE_EVENT_INFO:                null,
        COURSE_EVENT_INFO_ERROR:          null,
        COURSE_EVENT_SAVE:                null,
        COURSE_EVENT_SAVE_ERROR:          null,
        COURSE_EVENT_UPDATE:              null,
        COURSE_EVENT_UPDATE_ERROR:        null,
        COURSE_EVENT_DELETE:              null,
        COURSE_EVENT_DELETE_ERROR:        null,
        COURSE_ENROLMENT_LIST:            null,
        COURSE_ENROLMENT_LIST_ERROR:      null,
        COURSE_ENROLMENT_INFO_REQUEST:      null,
        COURSE_ENROLMENT_INFO_SUCCESS:      null,
        COURSE_ENROLMENT_INFO_FAILURE:      null,
        COURSE_ENROLMENT_SAVE:             null,
        COURSE_ENROLMENT_SAVE_ERROR:       null,
        COURSE_ENROLMENT_UPDATE_REQUEST:     null,
        COURSE_ENROLMENT_UPDATE_SUCCESS:     null,
        COURSE_ENROLMENT_UPDATE_FAILURE:     null,
        COURSE_ENROLMENT_BULK_UPDATE_REQUEST: null,
        COURSE_ENROLMENT_BULK_UPDATE_SUCCESS: null,
        COURSE_ENROLMENT_BULK_UPDATE_FAILURE: null,
        COURSE_ENROLMENT_DELETE_REQUEST:    null,
        COURSE_ENROLMENT_DELETE_SUCCESS:    null,
        COURSE_ENROLMENT_DELETE_FAILURE:    null,
        COURSE_ENROLMENT_BULK_DELETE_REQUEST: null,
        COURSE_ENROLMENT_BULK_DELETE_SUCCESS: null,
        COURSE_ENROLMENT_BULK_DELETE_FAILURE: null,
        COURSE_ENROLMENT_BY_FILTER_SAVE_REQUEST: null,
        COURSE_ENROLMENT_BY_FILTER_SAVE_SUCCESS: null,
        COURSE_ENROLMENT_BY_FILTER_SAVE_FAILURE: null,
        COURSE_ENROLMENT_CHECK_COMPLETE_REQUEST: null,
        COURSE_ENROLMENT_CHECK_COMPLETE_SUCCESS: null,
        COURSE_ENROLMENT_CHECK_COMPLETE_FAILURE: null,
        COURSE_ENROLMENT_STATS_REQUEST:   null,
        COURSE_ENROLMENT_STATS_SUCCESS:   null,
        COURSE_ENROLMENT_STATS_FAILURE:   null,
        COURSE_ENROLMENT_EMAIL_SEND_REQUEST:     null,
        COURSE_ENROLMENT_EMAIL_SEND_SUCCESS:     null,
        COURSE_ENROLMENT_EMAIL_SEND_FAILURE:     null,

        COURSE_ACTIVITY_TINCAN_LIST:       null,
        COURSE_ACTIVITY_TINCAN_LIST_ERROR: null,
        COURSE_CATEGORY_LIST:              null,
        COURSE_CATEGORY_LIST_ERROR:        null,
        COURSE_STATUS_OPTION_LIST:         null,
        COURSE_TYPE_OPTION_LIST:           null,

        COURSE_COMPLIANCE_LIST_REQUEST:     null,
        COURSE_COMPLIANCE_LIST_SUCCESS:     null,
        COURSE_COMPLIANCE_LIST_FAILURE:     null,

        COURSE_TRAINER_LIST_SUCCESS:        null,
        COURSE_TRAINER_LIST_FAILURE:        null,
        COURSE_MEDIA_INFO:                 null,
        COURSE_MEDIA_INFO_ERROR:           null,
        COURSE_MEDIA_PUBLISH:              null,
        COURSE_MEDIA_PUBLISH_ERROR:        null,

        COURSE_MODULE_INFO_REQUEST:        null,
        COURSE_MODULE_INFO_SUCCESS:        null,
        COURSE_MODULE_INFO_FAILURE:        null,
        COURSE_MODULE_LIST:                null,
        COURSE_MODULE_LIST_ERROR:          null,
        COURSE_MODULE_SAVE:                null,
        COURSE_MODULE_SAVE_ERROR:          null,
        COURSE_MODULE_UPDATE:                null,
        COURSE_MODULE_UPDATE_ERROR:          null,
        COURSE_MODULE_DELETE:              null,
        COURSE_MODULE_DELETE_ERROR:        null,

        COURSE_MODULE_SUBSCRIPTION_LIST_REQUEST:    null,
        COURSE_MODULE_SUBSCRIPTION_LIST_SUCCESS:    null,
        COURSE_MODULE_SUBSCRIPTION_LIST_FAILURE:    null,

        COURSE_MODULE_MOVE_UP_REQUEST: null,
        COURSE_MODULE_MOVE_UP_SUCCESS: null,
        COURSE_MODULE_MOVE_UP_FAILURE: null,

        COURSE_REGISTRATION_SAVE:           null,
        COURSE_REGISTRATION_SAVE_ERROR:     null,
        COURSE_PROGRESS_LIST_REQUEST:       null,
        COURSE_PROGRESS_LIST_SUCCESS:       null,
        COURSE_PROGRESS_LIST_FAILURE:       null,
        COURSE_MY_CLASS_STATS:              null,
        COURSE_CLASS_LIST:                  null,
        COURSE_CLASS_LIST_ERROR:            null,

        COURSE_LABEL_ADD_REQUEST:    null,
        COURSE_LABEL_ADD_SUCCESS:    null,
        COURSE_LABEL_ADD_FAILURE:    null,
        COURSE_LABEL_REMOVE_REQUEST: null,
        COURSE_LABEL_REMOVE_SUCCESS: null,
        COURSE_LABEL_REMOVE_FAILURE: null,

        COUNTRY_LIST:                        null,
        COUNTRY_LIST_ERROR:                  null,

        DEPARTMENT_LIST:                      null,
        DEPARTMENT_LIST_ERROR:                null,
        DEPARTMENT_INFO:                      null,
        DEPARTMENT_INFO_ERROR:                null,
        DEPARTMENT_SAVE:                      null,
        DEPARTMENT_SAVE_ERROR:                null,
        DEPARTMENT_UPDATE:                    null,
        DEPARTMENT_UPDATE_ERROR:              null,
        DEPARTMENT_DEFAULT:                   null,
        DEPARTMENT_DEFAULT_ERROR:             null,
        DEPARTMENT_DELETE:                    null,
        DEPARTMENT_DELETE_ERROR:              null,

        DEPARTMENT_STATS:                     null,
        DEPARTMENT_STATS_ERROR:               null,
        DEPARTMENT_MEMBERS_LIST_REQUEST:      null,
        DEPARTMENT_MEMBERS_LIST_SUCCESS:      null,
        DEPARTMENT_MEMBERS_LIST_FAILURE:      null,

        ENROLMENT_STATS:                    null,
        ENROLMENT_USER_STATS:               null,
        ENROLMENT_MODULE_STATS:             null,
        ENROLMENT_STATS_ERROR:              null,
        ENROLMENT_LIST:                     null,
        ENROLMENT_USER_LIST:                null,
        ENROLMENT_MODULE_LIST:              null,
        ENROLMENT_LIST_ERROR:               null,
        ENROLMENT_INFO:                     null,
        ENROLMENT_INFO_ERROR:               null,
        ENROLMENT_SAVE:                     null,
        ENROLMENT_SAVE_ERROR:               null,
        ENROLMENT_UPDATE:                   null,
        ENROLMENT_UPDATE_ERROR:             null,
        ENROLMENT_DELETE:                   null,
        ENROLMENT_DELETE_ERROR:             null,

        EVENT_EMAIL_SEND_BULK_REQUEST: null,
        EVENT_EMAIL_SEND_BULK_SUCCESS: null,
        EVENT_EMAIL_SEND_BULK_FAILURE: null,

        EMAIL_SEND_BULK_REQUEST: null,
        EMAIL_SEND_BULK_SUCCESS: null,
        EMAIL_SEND_BULK_FAILURE: null,

        EMAIL_TEMPLATE_STATS:                null,
        EMAIL_TEMPLATE_STATS_ERROR:          null,
        EMAIL_TEMPLATE_LIST:                 null,
        EMAIL_TEMPLATE_LIST_ERROR:           null,
        EMAIL_TEMPLATE_INFO:                 null,
        EMAIL_TEMPLATE_INFO_ERROR:           null,
        EMAIL_TEMPLATE_SAVE:                 null,
        EMAIL_TEMPLATE_SAVE_ERROR:           null,
        EMAIL_TEMPLATE_UPDATE:               null,
        EMAIL_TEMPLATE_UPDATE_ERROR:         null,
        EMAIL_TEMPLATE_DELETE:               null,
        EMAIL_TEMPLATE_DELETE_ERROR:         null,
        EMAIL_TEMPLATE_TYPE_LIST:            null,
        EMAIL_TEMPLATE_TYPE_LIST_ERROR:      null,
        EMAIL_TEMPLATE_TYPE_INFO:            null,
        EMAIL_TEMPLATE_TYPE_INFO_ERROR:      null,
        EMAIL_TEMPLATE_TYPE_SAVE:            null,
        EMAIL_TEMPLATE_TYPE_SAVE_ERROR:      null,
        EMAIL_TEMPLATE_TYPE_UPDATE:          null,
        EMAIL_TEMPLATE_TYPE_UPDATE_ERROR:    null,
        EMAIL_TEMPLATE_TYPE_DELETE:          null,
        EMAIL_TEMPLATE_TYPE_DELETE_ERROR:    null,

        EVENT_LIST:                      null,
        EVENT_LIST_ERROR:                null,
        EVENT_INFO:                      null,
        EVENT_INFO_ERROR:                null,
        EVENT_SAVE:                      null,
        EVENT_SAVE_ERROR:                null,
        EVENT_UPDATE:                    null,
        EVENT_UPDATE_ERROR:              null,
        EVENT_DELETE:                    null,
        EVENT_DELETE_ERROR:              null,
        EVENT_STATUS_OPTION_LIST:        null,
        EVENT_TYPE_OPTION_LIST:          null,
        EVENT_ASSET_LIST:                null,
        EVENT_ASSET_LIST_ERROR:          null,
        EVENT_ASSET_INFO:                null,
        EVENT_ASSET_INFO_ERROR:          null,
        EVENT_ASSET_SAVE:                null,
        EVENT_ASSET_SAVE_ERROR:          null,
        EVENT_ASSET_UPDATE:              null,
        EVENT_ASSET_UPDATE_ERROR:        null,
        EVENT_ASSET_DELETE:              null,
        EVENT_ASSET_DELETE_ERROR:        null,

        EVENT_ASSET_LIST_REQUEST:        null,
        EVENT_ASSET_LIST_SUCCESS:        null,
        EVENT_ASSET_LIST_FAILURE:        null,
        EVENT_ASSET_ADD_REQUEST:         null,
        EVENT_ASSET_ADD_SUCCESS:         null,
        EVENT_ASSET_ADD_FAILURE:         null,
        EVENT_ASSET_REMOVE_REQUEST:      null,
        EVENT_ASSET_REMOVE_SUCCESS:      null,
        EVENT_ASSET_REMOVE_FAILURE:      null,

        EVENT_ATTENDEE_LIST_REQUEST: null,
        EVENT_ATTENDEE_LIST_SUCCESS: null,
        EVENT_ATTENDEE_LIST_FAILURE: null,

        EVENT_ATTENDEE_INFO_REQUEST: null,
        EVENT_ATTENDEE_INFO_SUCCESS: null,
        EVENT_ATTENDEE_INFO_FAILURE: null,

        EVENT_ATTENDEE_ADD_REQUEST: null,
        EVENT_ATTENDEE_ADD_SUCCESS: null,
        EVENT_ATTENDEE_ADD_FAILURE: null,

        EVENT_ATTENDEE_SAVE_REQUEST: null,
        EVENT_ATTENDEE_SAVE_SUCCESS: null,
        EVENT_ATTENDEE_SAVE_FAILURE: null,

        EVENT_ATTENDEE_DELETE_REQUEST: null,
        EVENT_ATTENDEE_DELETE_SUCCESS: null,
        EVENT_ATTENDEE_DELETE_FAILURE: null,

        EVENT_ATTENDEE_UPDATE:          null,
        EVENT_ATTENDEE_UPDATE_ERROR:    null,
        EVENT_ATTENDEE_REMOVE:          null,
        EVENT_ATTENDEE_REMOVE_ERROR:    null,

        EVENT_BOOK:                     null,

        EVENT_NOTIFICATION_LIST_REQUEST: null,
        EVENT_NOTIFICATION_LIST_SUCCESS: null,
        EVENT_NOTIFICATION_LIST_FAILURE: null,
        EVENT_REMINDER_LIST:            null,
        EVENT_REMINDER_LIST_ERROR:      null,
        EVENT_REMINDER_INFO_REQUEST: null,
        EVENT_REMINDER_INFO_SUCCESS: null,
        EVENT_REMINDER_INFO_FAILURE: null,
        EVENT_REMINDER_SAVE:            null,
        EVENT_REMINDER_SAVE_ERROR:      null,
        EVENT_REMINDER_REMOVE:          null,
        EVENT_REMINDER_REMOVE_ERROR:    null,

        FILTER_LIST:                     null,
        FILTER_LIST_ERROR:               null,
        FILTER_INFO:                     null,
        FILTER_INFO_ERROR:               null,
        FILTER_SAVE:                     null,
        FILTER_SAVE_ERROR:               null,
        FILTER_UPDATE:                   null,
        FILTER_UPDATE_ERROR:             null,
        FILTER_DELETE:                   null,
        FILTER_DELETE_ERROR:             null,
        FILTER_RESULTS_REQUEST: null,
        FILTER_RESULTS_SUCCESS: null,
        FILTER_RESULTS_FAILURE: null,

        LABEL_LIST_REQUEST:   null,
        LABEL_LIST_SUCCESS:   null,
        LABEL_LIST_FAILURE:   null,
        LABEL_SAVE_REQUEST:   null,
        LABEL_SAVE_SUCCESS:   null,
        LABEL_SAVE_FAILURE:   null,
        LABEL_UPDATE_REQUEST: null,
        LABEL_UPDATE_SUCCESS: null,
        LABEL_UPDATE_FAILURE: null,
        LABEL_DELETE_REQUEST: null,
        LABEL_DELETE_SUCCESS: null,
        LABEL_DELETE_FAILURE: null,

        TRAINER_LIST:                   null,
        TRAINER_LIST_ERROR:             null,

        MANAGER_LIST_REQUEST:           null,
        MANAGER_LIST_SUCCESS:           null,
        MANAGER_LIST_FAILURE:           null,

        LOCATION_LIST_REQUEST: null,
        LOCATION_LIST_SUCCESS: null,
        LOCATION_LIST_FAILURE: null,
        LOCATION_INFO_REQUEST: null,
        LOCATION_INFO_SUCCESS: null,
        LOCATION_INFO_FAILURE: null,
        LOCATION_SAVE_REQUEST: null,
        LOCATION_SAVE_SUCCESS: null,
        LOCATION_SAVE_FAILURE: null,
        LOCATION_UPDATE_REQUEST: null,
        LOCATION_UPDATE_SUCCESS: null,
        LOCATION_UPDATE_FAILURE: null,
        LOCATION_DELETE_REQUEST: null,
        LOCATION_DELETE_SUCCESS: null,
        LOCATION_DELETE_FAILURE: null,

        LOCATION_CONTACT_LIST:            null,
        LOCATION_CONTACT_LIST_ERROR:      null,
        LOCATION_CONTACT_ADD:             null,
        LOCATION_CONTACT_ADD_ERROR:       null,

        LOCATION_EVENT_LIST_REQUEST: null,
        LOCATION_EVENT_LIST_SUCCESS: null,
        LOCATION_EVENT_LIST_FAILURE: null,

        LOCATION_TYPE_LIST:               null,
        LOCATION_TYPE_LIST_ERROR:         null,
        LOCATION_TYPE_INFO:               null,
        LOCATION_TYPE_INFO_ERROR:         null,
        LOCATION_TYPE_SAVE:               null,
        LOCATION_TYPE_SAVE_ERROR:         null,
        LOCATION_TYPE_UPDATE:             null,
        LOCATION_TYPE_UPDATE_ERROR:       null,
        LOCATION_TYPE_DELETE:             null,
        LOCATION_TYPE_DELETE_ERROR:       null,
        LOCATION_STATUS_LIST: null,
        LOCATION_STATUS_LIST_ERROR: null,
        LRS_USER_ACTIVITY_REQUEST:          null,
        LRS_USER_ACTIVITY_SUCCESS:          null,
        LRS_USER_ACTIVITY_FAILURE:          null,
        LRS_REGISTRATION_ACTIVITY_REQUEST:  null,
        LRS_REGISTRATION_ACTIVITY_SUCCESS:  null,
        LRS_REGISTRATION_ACTIVITY_FAILURE:  null,
        LRS_REGISTRATION_ACTIVITY_CLEANUP:  null,

        LRS_STATEMENTS_REQUEST: null,
        LRS_STATEMENTS_SUCCESS: null,
        LRS_STATEMENTS_FAILURE: null,

        MESSAGE_REMOVE:                   null,

        MODULE_LIST:                      null,
        MODULE_LIST_ERROR:                null,
        MODULE_INFO:                      null,
        MODULE_INFO_ERROR:                null,
        MODULE_ADD:                       null,
        MODULE_ADD_ERROR:                 null,
        MODULE_UPDATE:                    null,
        MODULE_UPDATE_ERROR:              null,
        MODULE_DELETE:                    null,
        MODULE_DELETE_ERROR:              null,

        MODULE_IMPORT_REQUEST:            null,
        MODULE_IMPORT_SUCCESS:            null,
        MODULE_IMPORT_FAILURE:            null,
        MODULE_IMPORT_SET_TARGET_FILE:    null,
        MODULE_IMPORT_SET_PROCESSED:      null,

        MODULE_ACCESS_GROUP_LIST_REQUEST:   null,
        MODULE_ACCESS_GROUP_LIST_SUCCESS:   null,
        MODULE_ACCESS_GROUP_LIST_FAILURE:   null,
        MODULE_ACCESS_GROUP_ADD_REQUEST:    null,
        MODULE_ACCESS_GROUP_ADD_SUCCESS:    null,
        MODULE_ACCESS_GROUP_ADD_FAILURE:    null,
        MODULE_ACCESS_GROUP_REMOVE_REQUEST: null,
        MODULE_ACCESS_GROUP_REMOVE_SUCCESS: null,
        MODULE_ACCESS_GROUP_REMOVE_FAILURE: null,

        MODULE_ASSET_LIST:                null,
        MODULE_ASSET_LIST_ERROR:          null,
        MODULE_ASSET_INFO:                null,
        MODULE_ASSET_INFO_ERROR:          null,
        MODULE_ASSET_ADD:                 null,
        MODULE_ASSET_ADD_ERROR:           null,
        MODULE_ASSET_UPDATE:              null,
        MODULE_ASSET_UPDATE_ERROR:        null,
        MODULE_ASSET_DELETE:              null,
        MODULE_ASSET_DELETE_ERROR:        null,

        MODULE_SUBSCRIPTION_LIST_REQUEST:           null,
        MODULE_SUBSCRIPTION_LIST_SUCCESS:           null,
        MODULE_SUBSCRIPTION_LIST_FAILURE:           null,
        MODULE_SUBSCRIPTION_INFO_REQUEST:           null,
        MODULE_SUBSCRIPTION_INFO_SUCCESS:           null,
        MODULE_SUBSCRIPTION_INFO_FAILURE:           null,
        MODULE_SUBSCRIPTION_SAVE_REQUEST:           null,
        MODULE_SUBSCRIPTION_SAVE_SUCCESS:           null,
        MODULE_SUBSCRIPTION_SAVE_FAILURE:           null,
        MODULE_SUBSCRIPTION_BY_FILTER_SAVE_REQUEST: null,
        MODULE_SUBSCRIPTION_BY_FILTER_SAVE_SUCCESS: null,
        MODULE_SUBSCRIPTION_BY_FILTER_SAVE_FAILURE: null,
        MODULE_SUBSCRIPTION_SWITCH_REQUEST: null,
        MODULE_SUBSCRIPTION_SWITCH_SUCCESS: null,
        MODULE_SUBSCRIPTION_SWITCH_FAILURE: null,
        MODULE_SUBSCRIPTION_DELETE_REQUEST:         null,
        MODULE_SUBSCRIPTION_DELETE_SUCCESS:         null,
        MODULE_SUBSCRIPTION_DELETE_FAILURE:         null,

        MODULE_EVENT_ADD_REQUEST: null,
        MODULE_EVENT_ADD_SUCCESS: null,
        MODULE_EVENT_ADD_FAILURE: null,
        MODULE_EVENT_LIST_REQUEST: null,
        MODULE_EVENT_LIST_SUCCESS: null,
        MODULE_EVENT_LIST_FAILURE: null,
        MODULE_EVENT_INFO_REQUEST: null,
        MODULE_EVENT_INFO_SUCCESS: null,
        MODULE_EVENT_INFO_FAILURE: null,
        MODULE_EVENT_DELETE_REQUEST: null,
        MODULE_EVENT_DELETE_SUCCESS: null,
        MODULE_EVENT_DELETE_FAILURE: null,


        MODULE_EVENT_ASSIGN_REQUEST: null,
        MODULE_EVENT_ASSIGN_SUCCESS: null,
        MODULE_EVENT_ASSIGN_FAILURE: null,

        MODULE_STATUS_OPTION_LIST:        null,
        MODULE_TYPE_LIST_REQUEST: null,
        MODULE_TYPE_LIST_SUCCESS: null,
        MODULE_TYPE_LIST_FAILURE: null,

        MODULE_SKILL_LIST:                null,
        MODULE_SKILL_LIST_ERROR:          null,
        MODULE_SKILL_ADD:                 null,
        MODULE_SKILL_ADD_ERROR:           null,
        MODULE_SKILL_DELETE:              null,
        MODULE_SKILL_DELETE_ERROR:        null,

        MODULE_TRAINER_ADD_REQUEST:         null,
        MODULE_TRAINER_ADD_SUCCESS:         null,
        MODULE_TRAINER_ADD_FAILURE:         null,
        MODULE_TRAINER_LIST_REQUEST:        null,
        MODULE_TRAINER_LIST_SUCCESS:        null,
        MODULE_TRAINER_LIST_FAILURE:        null,
        MODULE_TRAINER_DELETE_REQUEST:      null,
        MODULE_TRAINER_DELETE_SUCCESS:      null,
        MODULE_TRAINER_DELETE_FAILURE:      null,

        MODULE_CLASS_LIST_REQUEST:          null,
        MODULE_CLASS_LIST_SUCCESS:          null,
        MODULE_CLASS_LIST_FAILURE:          null,

        MODULE_MEDIA_INFO_REQUEST:                null,
        MODULE_MEDIA_INFO_SUCCESS:                null,
        MODULE_MEDIA_INFO_FAILURE:                null,
        MODULE_MEDIA_PUBLISH_REQUEST:     null,
        MODULE_MEDIA_PUBLISH_SUCCESS:     null,
        MODULE_MEDIA_PUBLISH_FAILURE:       null,

        MODULE_REGISTRATION_SAVE_REQUEST:   null,
        MODULE_REGISTRATION_SAVE_SUCCESS:   null,
        MODULE_REGISTRATION_SAVE_FAILURE:   null,

        MODULE_REMINDER_ADD_REQUEST: null,
        MODULE_REMINDER_ADD_SUCCESS: null,
        MODULE_REMINDER_ADD_FAILURE: null,
        MODULE_REMINDER_LIST_REQUEST: null,
        MODULE_REMINDER_LIST_SUCCESS: null,
        MODULE_REMINDER_LIST_FAILURE: null,
        MODULE_REMINDER_UPDATE_REQUEST: null,
        MODULE_REMINDER_UPDATE_SUCCESS: null,
        MODULE_REMINDER_UPDATE_FAILURE: null,
        MODULE_REMINDER_DELETE_REQUEST: null,
        MODULE_REMINDER_DELETE_SUCCESS: null,
        MODULE_REMINDER_DELETE_FAILURE: null,
        MODULE_REMINDER_DELETE_ALL_REQUEST: null,
        MODULE_REMINDER_DELETE_ALL_SUCCESS: null,
        MODULE_REMINDER_DELETE_ALL_FAILURE: null,

        NOTIFICATION_RECEIVED:            null,
        NOTIFICATION_LIST:                null,
        NOTIFICATION_LIST_ERROR:          null,
        NOTIFICATION_ERROR:               null,
        NOTIFICATION_INFO:                null,
        NOTIFICATION_INFO_ERROR:          null,
        NOTIFICATION_UPDATE:              null,
        NOTIFICATION_UPDATE_ERROR:        null,
        NOTIFICATION_DELETE:              null,
        NOTIFICATION_DELETE_ERROR:        null,

        ORGANISATION_LIST:                null,
        ORGANISATION_LIST_ERROR:          null,
        ORGANISATION_INFO:                null,
        ORGANISATION_INFO_ERROR:          null,
        ORGANISATION_SAVE:                null,
        ORGANISATION_SAVE_ERROR:          null,
        ORGANISATION_UPDATE:              null,
        ORGANISATION_UPDATE_ERROR:        null,
        ORGANISATION_DEFAULT:             null,
        ORGANISATION_DEFAULT_ERROR:       null,
        ORGANISATION_DELETE:              null,
        ORGANISATION_DELETE_ERROR:        null,

        ORGANISATION_CONTACT_LIST:          null,
        ORGANISATION_CONTACT_LIST_ERROR:    null,
        ORGANISATION_CONTACT_ADD:           null,
        ORGANISATION_CONTACT_ADD_ERROR:     null,
        ORGANISATION_CONTACT_REMOVE:        null,
        ORGANISATION_CONTACT_REMOVE_ERROR:  null,

        ORGANISATION_CATEGORY_LIST_REQUEST: null,
        ORGANISATION_CATEGORY_LIST_SUCCESS: null,
        ORGANISATION_CATEGORY_LIST_FAILURE: null,

        PERIODIC_TYPE_LIST:               null,
        PERIODIC_TYPE_LIST_ERROR:         null,

        PROGRAMME_STATS:                  null,
        PROGRAMME_STATS_ERROR:            null,
        PROGRAMME_LIST:                   null,
        PROGRAMME_LIST_ERROR:             null,
        PROGRAMME_INFO:                   null,
        PROGRAMME_INFO_ERROR:             null,
        PROGRAMME_SAVE:                   null,
        PROGRAMME_SAVE_ERROR:             null,
        PROGRAMME_UPDATE:                 null,
        PROGRAMME_UPDATE_ERROR:           null,
        PROGRAMME_DELETE:                 null,
        PROGRAMME_DELETE_ERROR:           null,

        PROGRAMME_COURSE_LIST:            null,
        PROGRAMME_COURSE_LIST_ERROR:      null,
        PROGRAMME_COURSE_SAVE:            null,
        PROGRAMME_COURSE_SAVE_ERROR:      null,
        PROGRAMME_COURSE_UPDATE:          null,
        PROGRAMME_COURSE_UPDATE_ERROR:    null,
        PROGRAMME_COURSE_DELETE:          null,
        PROGRAMME_COURSE_DELETE_ERROR:    null,

        REPORT_LIST:                null,
        REPORT_LIST_ERROR:          null,
        REPORT_INFO:                null,
        REPORT_INFO_ERROR:          null,
        REPORT_SAVE:                null,
        REPORT_SAVE_ERROR:          null,
        REPORT_UPDATE:              null,
        REPORT_UPDATE_ERROR:        null,
        REPORT_DELETE:              null,
        REPORT_DELETE_ERROR:        null,
        REPORT_RESULTS:             null,
        REPORT_RESULTS_ERROR:       null,
        REPORT_EMAIL_REQUEST:       null,
        REPORT_EMAIL_SUCCESS:       null,
        REPORT_EMAIL_FAILURE:       null,
        REPORT_SHARE_INFO_REQUEST:  null,
        REPORT_SHARE_INFO_SUCCESS:  null,
        REPORT_SHARE_INFO_FAILURE:  null,
        REPORT_SHARE_ADD_REQUEST:   null,
        REPORT_SHARE_ADD_SUCCESS:   null,
        REPORT_SHARE_ADD_FAILURE:   null,
        REPORT_SHARE_DELETE_REQUEST:  null,
        REPORT_SHARE_DELETE_SUCCESS:  null,
        REPORT_SHARE_DELETE_FAILURE:  null,
        REPORT_SHARE_RESULTS_REQUEST: null,
        REPORT_SHARE_RESULTS_SUCCESS: null,
        REPORT_SHARE_RESULTS_FAILURE: null,
        REPORT_SCHEDULE_LIST_REQUEST:    null,
        REPORT_SCHEDULE_LIST_SUCCESS:    null,
        REPORT_SCHEDULE_LIST_FAILURE:    null,
        REPORT_SCHEDULE_INFO_REQUEST:    null,
        REPORT_SCHEDULE_INFO_SUCCESS:    null,
        REPORT_SCHEDULE_INFO_FAILURE:    null,
        REPORT_SCHEDULE_ADD_REQUEST:     null,
        REPORT_SCHEDULE_ADD_SUCCESS:     null,
        REPORT_SCHEDULE_ADD_FAILURE:     null,
        REPORT_SCHEDULE_UPDATE_REQUEST:  null,
        REPORT_SCHEDULE_UPDATE_SUCCESS:  null,
        REPORT_SCHEDULE_UPDATE_FAILURE:  null,
        REPORT_SCHEDULE_DELETE_REQUEST:  null,
        REPORT_SCHEDULE_DELETE_SUCCESS:  null,
        REPORT_SCHEDULE_DELETE_FAILURE:  null,

        REPORT_TYPE_LIST:              null,
        REPORT_TYPE_LIST_ERROR:        null,

        REGISTRATION_LIST_REQUEST: null,
        REGISTRATION_LIST_SUCCESS: null,
        REGISTRATION_LIST_FAILURE: null,

        SETTING_LIST_REQUEST:           null,
        SETTING_LIST_SUCCESS:           null,
        SETTING_LIST_FAILURE:           null,
        SETTING_SAVE_REQUEST:           null,
        SETTING_SAVE_SUCCESS:           null,
        SETTING_SAVE_FAILURE:           null,

        SKILL_LIST:                     null,
        SKILL_LIST_ERROR:               null,
        SKILL_INFO:                     null,
        SKILL_INFO_ERROR:               null,
        SKILL_SAVE:                     null,
        SKILL_SAVE_ERROR:               null,
        SKILL_UPDATE:                   null,
        SKILL_UPDATE_ERROR:             null,
        SKILL_DELETE:                   null,
        SKILL_DELETE_ERROR:             null,
        SKILL_LEVEL_OPTION_LIST:        null,
        SKILL_TYPE_OPTION_LIST:         null,
        SKILL_GROUP_OPTION_LIST:        null,

        STATS_INFO_REQUEST:             null,
        STATS_INFO_SUCCESS:             null,
        STATS_INFO_FAILURE:             null,

        THEME_STATS:                    null,
        THEME_STATS_ERROR:              null,
        THEME_LIST:                     null,
        THEME_LIST_ERROR:               null,

        USER_LIST:                      null,
        USER_LIST_ERROR:                null,
        USER_INFO:                      null,
        USER_INFO_ERROR:                null,
        USER_SAVE:                      null,
        USER_SAVE_ERROR:                null,
        USER_UPDATE:                    null,
        USER_UPDATE_ERROR:              null,
        USER_DELETE:                    null,
        USER_DELETE_ERROR:              null,
        USER_RESTORE_DELETED_REQUEST:   null,
        USER_RESTORE_DELETED_SUCCESS:   null,
        USER_RESTORE_DELETED_FAILURE:   null,
        USER_PASSWORD_RESET:            null,
        USER_PASSWORD_RESET_ERROR:      null,
        USER_CHANGE_PASSWORD_REQUEST:   null,
        USER_CHANGE_PASSWORD_SUCCESS:   null,
        USER_CHANGE_PASSWORD_FAILURE:   null,
        USER_WELCOME_EMAIL_REQUEST:     null,
        USER_WELCOME_EMAIL_SUCCESS:     null,
        USER_WELCOME_EMAIL_FAILURE:     null,
        MISSING_WELCOME_EMAILS:         null,
        MISSING_WELCOME_EMAILS_ERROR:   null,
        USER_IMPORT_REQUEST:            null,
        USER_IMPORT_SUCCESS:            null,
        USER_IMPORT_FAILURE:            null,
        USER_IMPORT_SET_TARGET_FILE:    null,
        USER_IMPORT_SET_PROCESSED:      null,
        USER_IMPORT_HEADERS_REQUEST:    null,
        USER_IMPORT_HEADERS_SUCCESS:    null,
        USER_IMPORT_HEADERS_FAILURE:    null,
        USER_USERNAME_VALIDATE_REQUEST: null,
        USER_USERNAME_VALIDATE_SUCCESS: null,
        USER_USERNAME_VALIDATE_FAILURE: null,
        USER_IAM_SYNC_REQUEST:          null,
        USER_IAM_SYNC_SUCCESS:          null,
        USER_IAM_SYNC_FAILURE:          null,
        USER_TOKENS_CLEAR_REQUEST:      null,
        USER_TOKENS_CLEAR_SUCCESS:      null,
        USER_TOKENS_CLEAR_FAILURE:      null,

        USER_AUTH_METHOD_LIST_REQUEST: null,
        USER_AUTH_METHOD_LIST_SUCCESS: null,
        USER_AUTH_METHOD_LIST_FAILURE: null,

        USER_COMPLIANCE_LIST_REQUEST: null,
        USER_COMPLIANCE_LIST_SUCCESS: null,
        USER_COMPLIANCE_LIST_FAILURE: null,
        USER_COMPLIANCE_ADD_REQUEST: null,
        USER_COMPLIANCE_ADD_SUCCESS: null,
        USER_COMPLIANCE_ADD_FAILURE: null,
        USER_COMPLIANCE_REMOVE_REQUEST: null,
        USER_COMPLIANCE_REMOVE_SUCCESS: null,
        USER_COMPLIANCE_REMOVE_FAILURE: null,

        USER_COURSE_ENROL:              null,
        USER_COURSE_ENROL_ERROR:        null,

        USER_COURSE_WAITINGLIST_REMOVE:        null,
        USER_COURSE_WAITINGLIST_REMOVE_ERROR:  null,
        USER_COURSE_WAITINGLIST_ADD:           null,
        USER_COURSE_WAITINGLIST_ADD_ERROR:     null,

        USER_DEPARTMENT_SAVE:           null,
        USER_DEPARTMENT_SAVE_ERROR:     null,
        USER_DEPARTMENT_REMOVE_REQUEST: null,
        USER_DEPARTMENT_REMOVE_SUCCESS: null,
        USER_DEPARTMENT_REMOVE_FAILURE: null,

        USER_GROUP_ADD:                 null,
        USER_GROUP_ADD_ERROR:           null,
        USER_GROUP_REMOVE_REQUEST:      null,
        USER_GROUP_REMOVE_SUCCESS:      null,
        USER_GROUP_REMOVE_FAILURE:      null,

        USER_MANAGER_SAVE:              null,
        USER_MANAGER_SAVE_ERROR:        null,
        USER_MANAGER_REMOVE:            null,
        USER_MANAGER_REMOVE_ERROR:      null,

        USER_GROUP_LIST:                 null,
        USER_GROUP_LIST_ERROR:           null,
        USER_GROUP_INFO:                 null,
        USER_GROUP_INFO_ERROR:           null,
        USER_GROUP_SAVE:                 null,
        USER_GROUP_SAVE_ERROR:           null,
        USER_GROUP_UPDATE:               null,
        USER_GROUP_UPDATE_ERROR:         null,
        USER_GROUP_DELETE:               null,
        USER_GROUP_DELETE_ERROR:         null,

        USER_GROUP_MEMBERS_LIST_REQUEST: null,
        USER_GROUP_MEMBERS_LIST_SUCCESS: null,
        USER_GROUP_MEMBERS_LIST_FAILURE: null,

        USER_SKILL_INFO_REQUEST:        null,
        USER_SKILL_INFO_SUCCESS:        null,
        USER_SKILL_INFO_FAILURE:        null,
        USER_SKILL_LIST:                null,
        USER_SKILL_LIST_ERROR:          null,
        USER_SKILL_SAVE:                null,
        USER_SKILL_SAVE_ERROR:          null,
        USER_SKILL_UPDATE_REQUEST:      null,
        USER_SKILL_UPDATE_SUCCESS:      null,
        USER_SKILL_UPDATE_FAILURE:      null,
        USER_SKILL_REMOVE_REQUEST:      null,
        USER_SKILL_REMOVE_SUCCESS:      null,
        USER_SKILL_REMOVE_FAILURE:      null,

        VENDOR_LIST:                    null,
        VENDOR_LIST_ERROR:              null,
        VENDOR_SAVE:                    null,
        VENDOR_SAVE_ERROR:              null,
        VENDOR_INFO:                    null,
        VENDOR_INFO_ERROR:              null,
        VENDOR_UPDATE:                  null,
        VENDOR_UPDATE_ERROR:            null,
        VENDOR_DELETE:                  null,
        VENDOR_DELETE_ERROR:            null,

        VENUE_LIST:                     null,
        VENUE_LIST_ERROR:               null,
        VENUE_INFO:                     null,
        VENUE_INFO_ERROR:               null,
        VENUE_SAVE:                     null,
        VENUE_SAVE_ERROR:               null,
        VENUE_UPDATE:                   null,
        VENUE_UPDATE_ERROR:             null,
        VENUE_DELETE:                   null,
        VENUE_DELETE_ERROR:             null,

        VENUE_ASSET_LIST_REQUEST:       null,
        VENUE_ASSET_LIST_SUCCESS:       null,
        VENUE_ASSET_LIST_FAILURE:       null,
        VENUE_ASSET_ADD_REQUEST:        null,
        VENUE_ASSET_ADD_SUCCESS:        null,
        VENUE_ASSET_ADD_FAILURE:        null,
        VENUE_ASSET_REMOVE_REQUEST:     null,
        VENUE_ASSET_REMOVE_SUCCESS:     null,
        VENUE_ASSET_REMOVE_FAILURE:     null,
        VENUE_ASSET_SAVE:               null,
        VENUE_ASSET_SAVE_ERROR:         null,

        VENUE_EVENT_LIST:               null,
        VENUE_EVENT_LIST_ERROR:         null,

        VENUE_LOCATION_LIST:            null,
        VENUE_LOCATION_LIST_ERROR:      null,
        VENUE_LOCATION_INFO:            null,
        VENUE_LOCATION_INFO_ERROR:      null,
        VENUE_LOCATION_SAVE:            null,
        VENUE_LOCATION_SAVE_ERROR:      null,
        VENUE_LOCATION_UPDATE:          null,
        VENUE_LOCATION_UPDATE_ERROR:    null,
        VENUE_LOCATION_DELETE:          null,
        VENUE_LOCATION_DELETE_ERROR:    null,

        VENUE_CONTACT_LIST:             null,
        VENUE_CONTACT_LIST_ERROR:       null,
        VENUE_CONTACT_ADD:              null,
        VENUE_CONTACT_ADD_ERROR:        null,
        VENUE_CONTACT_REMOVE:           null,
        VENUE_CONTACT_REMOVE_ERROR:     null,

        SEARCH_REQUEST:                 null,
        SEARCH_SUCCESS:                 null,
        SEARCH_FAILURE:                 null,

        SEARCH_RESULT_RECEIVED:         null,
        SEARCH_ERROR:                   null,

        SYSTEM_TASK_LIST_REQUEST: null,
        SYSTEM_TASK_LIST_SUCCESS: null,
        SYSTEM_TASK_LIST_FAILURE: null,
        SYSTEM_TASK_INFO_REQUEST: null,
        SYSTEM_TASK_INFO_SUCCESS: null,
        SYSTEM_TASK_INFO_FAILURE: null,

        SYSTEM_TASK_JOB_LIST_REQUEST: null,
        SYSTEM_TASK_JOB_LIST_SUCCESS: null,
        SYSTEM_TASK_JOB_LIST_FAILURE: null,

        MAIL_LOG_LIST:                 null,
        MAIL_LOG_LIST_ERROR:           null,

        GET_DATA_REQUEST: null,
        GET_DATA_SUCCESS: null,
        GET_DATA_FAILURE: null,

        DIALOG_OPEN:                    null,
        DIALOG_CLOSE:                   null,
        DIALOG_DRAFT_SET:               null,
        DIALOG_DRAFT_UPDATE:            null,
        DIALOG_DRAFT_BULK_UPDATE:       null
    }),

    DataTypes: keyMirror({
        FONT_LIST:          null,
        PAPER_SIZE_LIST:    null
    }),

    SearchTypes: keyMirror({
        DEFAULT:            null,
        ASSETS:             null,
        RESOURCES:          null,
        RESOURCES_CONTENT:  null,
        USERS:              null,
        COURSE_ENROLMENTS:  null,
        COURSES:            null,
        MODULES:            null,
        SKILLS:             null
    }),

    StatTypes: keyMirror({
        ASSIGNMENT_COUNT: null,
        AUTH_TOKEN_COUNT: null,
        COURSE_COUNT: null,
        COURSE_STATS: null,
        MODULE_COUNT: null,
        MY_CLASSES: null,
        MY_ENROLMENTS: null,
        MY_MODULES: null,
        MY_MODULES_COMPLETED: null,
        MY_MODULES_NOT_COMPLETED: null,
        MY_RESOURCE_STATS: null,
        RESOURCE_COUNT: null,
        USER_COUNT: null,
        USER_COUNT_ARCHIVED: null,
        USER_VISIT_STATS: null
    }),

    Settings: keyMirror({
        GOOGLE_API_KEY: null,
    }),

    DateStyles: {
        short:  {
            year:       'numeric',
            month:      'short',
            day:        'numeric'
        },
        shortWeekday: {
            day:        'numeric',
            weekday:    'short',
            year:       'numeric',
            month:      'short'
        },
        shortDateTime: {
            day:        'numeric',
            weekday:    'short',
            year:       'numeric',
            month:      'short',
            hour:       'numeric',
            minute:     'numeric'
        },
        longDateTime: {
            day:        'numeric',
            weekday:    'long',
            month:      'long',
            hour:       'numeric',
            minute:     'numeric',
        },
        long:   {
            year:       'numeric',
            month:      'long',
            day:        'numeric'
        },
        monthYear: {
            year:       'numeric',
            month:      'long',
        },
        full:   {
            day:        'numeric',
            weekday:    'long',
            year:       'numeric',
            month:      'long'
        },
        fullDay:   {
            day:        'numeric',
            weekday:    'short',
            month:      'long',
        },
        fullDateTime:   {
            day:        'numeric',
            weekday:    'short',
            year:       'numeric',
            month:      'short',
            hour:       'numeric',
            minute:     'numeric',
        },
        time:   {
            hour:       'numeric',
            minute:     'numeric',
        }
    }

};
